import type { ApiMagentoPlaceOrderError, MagentoPlaceOrderErrorCodes } from "@jti/magento-types";

const MAGENTO_PLACE_ORDER_ERROR_CODES: MagentoPlaceOrderErrorCodes[] = [
  "CART_NOT_FOUND",
  "CART_NOT_ACTIVE",
  "GUEST_EMAIL_MISSING",
  "UNABLE_TO_PLACE_ORDER",
  "UNDEFINED",
  "SALESRULE_GIFT_NOT_VALID",
] as const;

export const isMagentoPlaceOrderError = (error: unknown): error is ApiMagentoPlaceOrderError => {
  if (typeof error !== "object" || error === null) {
    return false;
  }

  const maybeError = error as ApiMagentoPlaceOrderError;

  return (
    typeof maybeError.message === "string" &&
    typeof maybeError.code === "string" &&
    MAGENTO_PLACE_ORDER_ERROR_CODES.includes(maybeError.code)
  );
};
